import React, {useEffect, useState} from "react";
import styled from "styled-components/macro";

import Helmet from "react-helmet";

import {
    Grid,
    Divider as MuiDivider,
    Typography,
} from "@material-ui/core";

import { spacing } from "@material-ui/system";
import {LOCAL_STORAGE_KEYS, ORG_TYPE} from "../../utils/constants";
import ListProfilesActivations from "./components/ListProfilesActivations";


const Divider = styled(MuiDivider)(spacing);


function PendingActivation() {

    const [listOfType, setListOfType] = useState('Employee');

    useEffect( ()=> {
        const org_type = localStorage.getItem(LOCAL_STORAGE_KEYS.active_org_type);
        if (org_type+'' === ORG_TYPE.SCHOOL+'') {
            setListOfType('Student');
        }
    }, [] )

    return (
        <React.Fragment>
            <Helmet title={`DQ-PRO | ${listOfType}s`} />
            <Typography variant="h3" gutterBottom display="inline">
                {listOfType} Pending Activation
            </Typography>

            <Divider my={6} />

            <Grid container spacing={6}>
                <Grid item xs={12}>
                    <ListProfilesActivations />
                </Grid>
            </Grid>
        </React.Fragment>
    );
}

export default PendingActivation;
